import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { PaymentSessionResponse } from '@/lib/api/generated/models'
import { formatCurrency } from '@/lib/utils'

interface OrderSummaryProps {
  paymentSession: PaymentSessionResponse
}

const OrderSummary = ({ paymentSession }: OrderSummaryProps) => {
  const { orderDetails, totalAmount, serviceFees, platformFees, currency } = paymentSession

  // Calculate subtotal from line items
  const subtotal = orderDetails.lineItems.reduce((sum, item) => sum + item.totalPrice, 0)

  return (
    <Card className="w-full max-w-md">
      <CardHeader className="bg-blue-50 text-blue-800 rounded-t-lg">
        <CardTitle>Order Summary</CardTitle>
        <CardDescription>Review your order details below.</CardDescription>
      </CardHeader>
      <CardContent className="grid gap-4 pt-6">
        {orderDetails.lineItems.map((item, index) => (
          <div key={index} className="flex justify-between">
            <span>
              {item.name} (x{item.quantity})
            </span>
            <span>{formatCurrency(item.totalPrice, currency)}</span>
          </div>
        ))}
        <div className="border-t pt-4">
          <div className="flex justify-between">
            <span>Subtotal</span>
            <span>{formatCurrency(subtotal, currency)}</span>
          </div>
          {serviceFees > 0 && (
            <div className="flex justify-between">
              <span>Service Fees</span>
              <span>{formatCurrency(serviceFees, currency)}</span>
            </div>
          )}
          {platformFees > 0 && (
            <div className="flex justify-between">
              <span>Platform Fees</span>
              <span>{formatCurrency(platformFees, currency)}</span>
            </div>
          )}
          <div className="flex justify-between font-bold">
            <span>Total</span>
            <span>{formatCurrency(totalAmount, currency)}</span>
          </div>
        </div>
      </CardContent>
      <CardFooter>
        <p className="text-sm text-gray-500">Powered by FanFair</p>
      </CardFooter>
    </Card>
  )
}

export default OrderSummary
